export const dates = {
	game: '26. června 2021',
	payment: '23. června 2021',
	teamChanges: '21. června 2021',
	year: 2021
};
